import React from 'react';
import WebDesignHero from '../components/WebDesignHero';
import AffordableWebDesignSection from '../components/AffordableWebDesignSection';
import WebDesignScrapToDevelopment from '../components/WebDesignScrapToDevelopment';
import WebDesignPortfolio from '../components/WebDesignPortfolio';
import WebDesignVisionSection from '../components/WebDesignVisionSection';
import WebDesignTailoredSolutions from '../components/WebDesignTailoredSolutions';
import WebDesignUiUxSection from '../components/WebDesignUiUxSection';
import WebDesignTestimonialsSlider from '../components/WebDesignTestimonialsSlider';
import ContactUs from '../components/ContactUs';

function WebDesignPage() {
  return (
    <>
      <WebDesignHero />
      <AffordableWebDesignSection />
      <WebDesignScrapToDevelopment />
      <WebDesignPortfolio />
      <WebDesignVisionSection />
      <WebDesignTailoredSolutions />
      <WebDesignUiUxSection />
      <WebDesignTestimonialsSlider />
      <ContactUs />
    </>
  );
}

export default WebDesignPage;
